module.exports = __webpack_public_path__ + "img/racecourse-vaal-turf-2400.5cc62a16.svg";